/* src/app/modules/search/components/doc-view/components/doc-container/doc-container.component.scss */
.doc-view-container {
  height: calc(100vh - var(--topNav-height));
  padding-right: 0.875rem;
  overflow: scroll;
}
.doc-view-container .doc-view-header {
  display: flex;
  justify-content: space-between;
  margin: 1px 0.1rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  align-items: flex-end;
}
.doc-view-container .doc-view-header .title-container .title {
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--surface-800);
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
}
.doc-view-container .doc-view-header .title-container .subtitle {
  font-size: 0.8rem;
  font-weight: 400;
  color: var(--surface-600);
}
.doc-view-container .doc-view-body {
  margin: 1px 0.1rem;
  border-radius: 0.5rem;
  margin-top: 0.5rem;
  padding-bottom: 0.2rem;
}
.doc-view-container .extracted-entity-viewer {
  overflow: auto;
  border-radius: 0.5rem;
  padding: 1rem;
  margin: 0.4rem 0.25rem;
  margin-bottom: 1px;
  margin-right: 1px;
}
.doc-view-container-new-tab {
  height: 100vh !important;
  overflow-y: auto;
  padding: 1rem !important;
}
.doc-view-body-container ::ng-deep p-splitter {
  width: 100%;
}
.doc-view-body-container ::ng-deep .p-splitter-horizontal {
  width: 100%;
}
.doc-view-body-container ::ng-deep .p-splitter-panel:first-child {
  width: 100% !important;
  min-width: 55% !important;
  transition: min-width 0.2s cubic-bezier(0.4, 0, 0.2, 1), overflow 0.2s ease-in-out;
}
.doc-view-body-container ::ng-deep .p-splitter-panel:last-child {
  min-width: 25%;
  transition: min-width 0.2s cubic-bezier(0.4, 0, 0.2, 1), overflow 0.2s ease-in-out;
}
.doc-view-body-container-entity ::ng-deep .p-splitter-gutter {
  display: none !important;
}
.doc-view-body-container-entity ::ng-deep .p-splitter-panel:first-child {
  flex-basis: 100% !important;
}
.doc-view-body-container-entity ::ng-deep .p-splitter-panel:last-child {
  flex-basis: 0 !important;
  width: 0 !important;
  min-width: 0 !important;
}
/*# sourceMappingURL=doc-container.component.css.map */
